import { render, staticRenderFns } from "./RequestConfirmationStep.vue?vue&type=template&id=4a254e96&"
import script from "./RequestConfirmationStep.vue?vue&type=script&lang=js&"
export * from "./RequestConfirmationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports